import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { navigate("/admin/login"); return; }
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(res.data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: res.data } });
      } catch {
        navigate("/admin/login");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-obsidian flex flex-col items-center justify-center gap-6">
      <Logo width={200} />
      <p className="text-muted-text text-sm tracking-widest uppercase">Signing you in…</p>
    </div>
  );
}
